import React from "react";

const Privacypolicy = () => {
  return (
    <div className="text-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-red-800 mb-6">Privacy Policy</h1>
        <p className="mb-4">
          Effective Date: <strong>May 13, 2025</strong>
        </p>

        <p className="mb-4">
          At <strong>New Way Security</strong>, we respect your privacy and are
          committed to protecting your personal information. This policy
          outlines how we collect, use, and safeguard the data of our website
          visitors, security guards, staff, and customers.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          1. Information We Collect
        </h2>
        <ul className="list-disc ml-6 mb-4">
          <li>Personal identification (name, email, phone, address)</li>
          <li>Account credentials (for staff, guards, and customers)</li>
          <li>Job applications and resumes</li>
          <li>Usage data (IP address, browser, device type)</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          2. How We Use Your Information
        </h2>
        <ul className="list-disc ml-6 mb-4">
          <li>To manage user accounts and security personnel</li>
          <li>To process applications and job assignments</li>
          <li>To provide customer service</li>
          <li>To improve website functionality</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-2">
          3. Sharing Your Information
        </h2>
        <p className="mb-4">
          We do not sell your data. We may share information with trusted
          partners who help us operate our platform, but only with your consent
          or as required by law.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">4. Data Security</h2>
        <p className="mb-4">
          We implement strict security protocols to protect your information
          using encrypted databases, role-based access, and regular audits.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">5. Your Rights</h2>
        <p className="mb-4">
          You can request to access, correct, or delete your personal data at
          any time by contacting us at{" "}
          <a
            href="mailto:info@newwaysecurity.com"
            className="text-blue-600 hover:underline"
          >
            info@newwaysecurity.com
          </a>
          .
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-2">6. Updates</h2>
        <p className="mb-4">
          We may update this policy from time to time. Changes will be posted on
          this page.
        </p>
      </div>
    </div>
  );
};

export default Privacypolicy;
